import { Task } from "gantt-task-react";
import React from "react";
import "./GanttRender.css";
import Tooltip from "../UiLib/CustomTooltip/CustomTooltip";

interface ExtendedTask extends Task {
    taskId?: number;
}

const formatDate = (date: Date): string => {
    return `${String(date.getDate()).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(
        2,
        "0"
    )}.${date.getFullYear()}`;
};

const CustomTaskListTable: React.FC<{ tasks: ExtendedTask[] }> = ({ tasks }) => {
    return (
        <div className="_2B2zv">
            {tasks.map((task) => (
                <div key={task.id} className="_34SS0" style={{ height: "50px",}}>
                    {/* Номер */}
                    <div className="_WuQ0f" style={{ minWidth: "100px" }}>
                        <div className="gant_render--taskRowText">{task.id}</div>
                    </div>
                    <div className="_2eZzQ" style={{ height: "25px", marginTop: "10px" }}></div>

                    {/* Наименование задачи */}
                    <div className="_WuQ0f" style={{ minWidth: "190px !important" }}>
                        <div className="gant_render--taskRowText">
                            <Tooltip text={task.name} placement="top" offset={5} >
                                <div className="gant_render--taskNameText">{task.name}</div>
                            </Tooltip>
                        </div>
                    </div>
                    <div className="_2eZzQ" style={{ height: "25px", marginTop: "10px" }}></div>

                    {/* Дата начала */}
                    <div className="_WuQ0f" style={{ minWidth: "100px", padding:"5px" }}>
                        <div className="gant_render--taskRowText">{formatDate(task.start)}</div>
                    </div>
                    <div className="_2eZzQ" style={{ height: "25px", marginTop: "12.5px" }}></div>

                    {/* Дата окончания */}
                    <div className="_WuQ0f" style={{ minWidth: "100px", padding:"5px" }}>
                        <div className="gant_render--taskRowText">{formatDate(task.end)}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CustomTaskListTable;
